import { clearSelectedMessagesList } from 'message/actions/selected-messages.actions';
import messageHelpers from '../message-helpers';
import actionTypes from './action-types';
import * as api from '../resources/message.api';

export const fetchMessagesListRequest = () => ({
  type: actionTypes.FETCH_MESSAGES_LIST_REQUEST,
  name: 'inboxLoadingStatus',
});

export const fetchMessagesListFailure = () => ({
  type: actionTypes.FETCH_MESSAGES_LIST_FAILURE,
  name: 'inboxLoadingStatus',
});

export const fetchMessagesListSuccess = (messages, pagination = {}) => ({
  type: actionTypes.FETCH_MESSAGES_LIST_SUCCESS,
  messages: messages.map((message) => {
    const content = messageHelpers.getShortenMessage(message.content);

    return {
      ...message,
      content,
    };
  }),
  pagination,
  name: 'inboxLoadingStatus',
});

export const fetchMessagesList =
  ({ setPagination = true, ...params }) =>
  async (dispatch, getStore) => {
    try {
      const store = getStore();
      const { messages } = store;
      const { hasAllMessagesSelected } = messages.selectedMessages;

      if (hasAllMessagesSelected) dispatch(clearSelectedMessagesList());

      dispatch(fetchMessagesListRequest());
      const { content, ...pagination } = await api.fetchMessagesList(params);

      if (setPagination) {
        dispatch(fetchMessagesListSuccess(content, pagination));
      } else {
        dispatch(fetchMessagesListSuccess(content));
      }
    } catch (error) {
      dispatch(fetchMessagesListFailure());
      console.error('FETCH_MESSAGES_LIST', error);
    }
  };

export const deleteMessagesRequest = () => ({
  type: actionTypes.DELETE_MESSAGES_REQUEST,
});

export const deleteMessagesFailure = () => ({
  type: actionTypes.DELETE_MESSAGES_FAILURE,
});

export const deleteMessagesSuccess = (selectedMessagesList, messages) => ({
  type: actionTypes.DELETE_MESSAGES_SUCCESS,
  selectedMessagesList,
  messages,
});

export const deleteMessages = () => async (dispatch, getStore) => {
  try {
    const { messages } = getStore();
    const { inbox: entries, selectedMessages } = messages;
    const { selectedMessagesList } = selectedMessages;

    dispatch(deleteMessagesRequest());
    await api.deleteReceivedMessages(selectedMessagesList);
    dispatch(deleteMessagesSuccess(selectedMessagesList, entries));
    dispatch(clearSelectedMessagesList());
  } catch (error) {
    dispatch(deleteMessagesFailure());
    console.error('DELETE_MESSAGES', error);
  }
};

export const deleteMessageRequest = () => ({
  type: actionTypes.DELETE_MESSAGE_REQUEST,
});

export const deleteMessageFailure = () => ({
  type: actionTypes.DELETE_MESSAGE_FAILURE,
});

export const deleteMessageSuccess = () => ({
  type: actionTypes.DELETE_MESSAGE_SUCCESS,
});

export const deleteMessage = (id) => async (dispatch) => {
  try {
    dispatch(deleteMessageRequest());
    await api.deleteReceivedMessages([id]);
    dispatch(deleteMessageSuccess());
  } catch (error) {
    dispatch(deleteMessageFailure());
    console.error('DELETE_MESSAGE', error);
  }
};

export const markMessageAsUnreadRequest = () => ({
  type: actionTypes.MARK_MESSAGE_AS_UNREAD_REQUEST,
});

export const markMessageAsUnreadFailure = () => ({
  type: actionTypes.MARK_MESSAGE_AS_UNREAD_FAILURE,
});

export const markMessageAsUnreadSuccess = (selectedMessagesList, messages) => ({
  type: actionTypes.MARK_MESSAGE_AS_UNREAD_SUCCESS,
  selectedMessagesList,
  messages,
});

export const markMessageAsUnread = () => async (dispatch, getStore) => {
  try {
    const { messages } = getStore();
    const { inbox: entries, selectedMessages } = messages;
    const { selectedMessagesList } = selectedMessages;

    const requests = selectedMessagesList.reduce((reguests, id) => [...reguests, ...[api.markMessageAsUnread(id)]], []);
    dispatch(markMessageAsUnreadRequest());
    await Promise.all(requests);
    dispatch(markMessageAsUnreadSuccess(selectedMessagesList, entries));
  } catch (error) {
    dispatch(markMessageAsUnreadFailure());
    console.error('MARK_MESSAGE_AS_UNREAD', error);
  }
};

export const markMessageAsReadRequest = () => ({
  type: actionTypes.MARK_MESSAGE_AS_READ_REQUEST,
});

export const markMessageAsReadFailure = () => ({
  type: actionTypes.MARK_MESSAGE_AS_READ_FAILURE,
});

export const markMessageAsReadSuccess = (selectedMessagesList, messages) => ({
  type: actionTypes.MARK_MESSAGE_AS_READ_SUCCESS,
  selectedMessagesList,
  messages,
});

export const markMessageAsRead = () => async (dispatch, getStore) => {
  try {
    const { messages } = getStore();
    const { inbox: entries, selectedMessages } = messages;
    const { selectedMessagesList } = selectedMessages;

    const requests = selectedMessagesList.reduce((reguests, id) => [...reguests, ...[api.markMessageAsRead(id)]], []);
    dispatch(markMessageAsReadRequest());
    await Promise.all(requests);
    dispatch(markMessageAsReadSuccess(selectedMessagesList, entries));
  } catch (error) {
    dispatch(markMessageAsReadFailure());
    console.error('MARK_MESSAGE_AS_READ', error);
  }
};

export const resetInbox = () => ({
  type: actionTypes.RESET_INBOX,
});



// WEBPACK FOOTER //
// ./src/modules/message/actions/inbox.actions.js